import AgentInterface from './AgentInterface';
import { BsDatabaseAdd } from 'react-icons/bs';

class InventoryAgent extends AgentInterface {
  constructor(config = {}) {
    super({
      name: 'Agente de Inventario de Activos',
      description: 'Soy experto en la consulta de Inventario de Activos.',
      icon: BsDatabaseAdd,
      webhookEndpoint: '/webhook/inputInvAct',
      ...config,
    });

    if (!config.n8nService) {
      throw new Error('n8nService es requerido para InventoryAgent');
    }
    this.n8nService = config.n8nService;
  }

  async sendMessage(message, context = {}) {
    try {
      const response = await this.n8nService.sendToWebhook(
        this.config.webhookEndpoint,
        {
          message,
          context: {
            userId: context.userId,
            sessionId: context.sessionId,
            // Puedes agregar más contexto si lo necesitas
          },
        }
      );

      return {
        success: true,
        response: response.message || 'No se recibió respuesta del asistente',
        metadata: response.metadata || {},
      };
    } catch (error) {
      console.error('Error en InventoryAgent:', error);
      return {
        success: false,
        error: 'No se pudo conectar con el agente de inventario. Por favor, inténtalo de nuevo más tarde.',
        originalError: error.message,
      };
    }
  }
}

export default InventoryAgent;